import React, { useMemo } from 'react';

import {
  SmartViewerFilter,
  type SmartViewerFilterValue,
} from '../../Components/ViewerFilter/SmartViewerFilter';
import {
  EMPTY_PLAYGROUND_FILTER,
  type PlaygroundFilterOption,
  type PlaygroundViewerFilter,
} from './quickInferenceUtils';

interface Props {
  filter: PlaygroundViewerFilter;
  onChange: (next: PlaygroundViewerFilter) => void;
  viewOptions: PlaygroundFilterOption[];
  structureOptions: PlaygroundFilterOption[];
  matchedCount: number;
  totalCount: number;
}

export function QuickInferenceViewerFilter({
  filter,
  onChange,
  viewOptions,
  structureOptions,
  matchedCount,
  totalCount,
}: Props) {
  const smartFilter: SmartViewerFilterValue = useMemo(
    () => ({
      contentScope: filter.contentScope,
      views: filter.views,
      structureIds: filter.structureIds,
    }),
    [filter]
  );

  return (
    <SmartViewerFilter
      filter={smartFilter}
      onChange={(next) => {
        if (
          next.contentScope === 'all' &&
          next.views.length === 0 &&
          next.structureIds.length === 0
        ) {
          onChange(EMPTY_PLAYGROUND_FILTER);
          return;
        }
        onChange({
          contentScope: next.contentScope,
          views: next.views,
          structureIds: next.structureIds.map(Number).filter((n) => Number.isFinite(n)),
        });
      }}
      viewOptions={viewOptions}
      structureOptions={structureOptions}
      matchedCount={matchedCount}
      totalCount={totalCount}
      showContentScope
      emptyViewsLabel="No views in this file"
      emptyStructuresLabel="No structures in this file"
    />
  );
}
